import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DetailsViewerComponent } from './details-viewer/details-viewer.component';
import { SharedModule } from '../../../shared/shared.module';
import { UIModule } from '../../ui/ui.module';
import { CustomersComponent } from './customers.component';
import { JvUiModule } from '../../../../../projects/jv-ui/src/lib/jv-ui.module';

@NgModule({
  imports: [
    CommonModule,
    SharedModule,
    UIModule,
    JvUiModule
  ],
  declarations: [DetailsViewerComponent, CustomersComponent],
  entryComponents: [DetailsViewerComponent]
})
export class CustomersModule { }
